import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container } from 'react-bootstrap';
import api from '../../../services/API';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import sortFunc from '../../../utils/ordernarColunaInt';
import { toast } from 'react-toastify';
import ModalExcluir from './ModalExcluir/index';
import ModalEditar from './ModalEditar/index';
import ModalLimiteResgate from './ModalLimiteResgate/index';
import { useSelector } from 'react-redux';
import '../Parceiros/styles.css';

const { SearchBar } = Search;

export default function Premios() {
  const usuario = useSelector((state) => {
    return state.usuario;
  });

  const [data, setData] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [dataEditar, setDataEditar] = useState(null);
  const [id, setId] = useState('');
  const [premio, setPremio] = useState('');
  const [mostrarModalExcluir, setMostrarModalExcluir] = useState(false);
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [totalSize, setTotalSize] = useState(0);
  const [tableKey, setTableKey] = useState(0);
  const [busca, setBusca] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [mostrarModalLimite, setMostrarModalLimite] = useState(false);
  const [premioLimite, setPremioLimite] = useState(null);

  const columns = [
    { dataField: 'id', text: 'ID', sort: false, hidden: true },
    {
      dataField: 'select',
      text: '',
      sort: false,
      formatter: (celula, valor) => (
        <input
          key={`checkbox-${valor.id}-${selectedIds.includes(valor.id)}`}
          type="checkbox"
          checked={selectedIds.includes(valor.id)}
          onChange={(e) => handleSelectChange(e, valor.id)}
        />
      ),
      headerFormatter: () => (
        <input
          key={`select-all-${selectAll}-${selectedIds.length}`}
          type="checkbox"
          checked={selectAll}
          onChange={handleSelectAllChange}
        />
      ),
    },
    { dataField: 'nome', text: 'Descrição', sort: true },
    {
      dataField: 'pontos',
      text: 'Pontos',
      sort: true,
      sortFunc: sortFunc,
      formatter: (celula, valor) => {
        const pontos = Number(valor.pontosWeb ?? valor.pontos ?? valor.custo ?? 0);
        return pontos.toLocaleString('pt-BR', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      },
      hidden: false,
    },
    { dataField: 'tipo', text: 'Tipo', sort: true },
    {
      dataField: 'limiteResgate',
      text: 'Limite de Resgate',
      sort: false,
      formatter: (celula, valor) => {
        const hasLimite = valor.hasLimiteResgate === true || valor.hasLimiteResgate === 1;
        const limiteAtual = valor.limiteResgate || '';
        
        return (
          <div className="d-flex align-items-center justify-content-center" style={{ gap: '10px' }}>
            <label 
              key={`switch-limite-${valor.id}-${hasLimite}`}
              className="switch"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                abrirModalLimite(valor);
              }}
            >
              {hasLimite ? (
                <input 
                  type="checkbox" 
                  checked 
                  readOnly
                />
              ) : (
                <input 
                  type="checkbox" 
                  readOnly
                />
              )}
              <span className="slider round"></span>
            </label>
            <span
              style={{ fontSize: '14px', cursor: 'pointer' }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                abrirModalLimite(valor);
              }}
            >
              {hasLimite ? limiteAtual : 'Sem limite'}
            </span>
          </div>
        );
      },
    },
    {
      dataField: 'ativo',
      text: 'Ativo',
      sort: true,
      hidden: [2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => {
        return (
          <span className={valor.ativo === 1 ? 'text-success' : 'text-danger'}>
            {valor.ativo === 1 ? 'Sim' : 'Não'}
          </span>
        );
      },
    },
    {
      dataField: 'switch',
      text: 'Ativar/Inativar',
      sort: false,
      hidden: false,
      formatter: (celula, valor) => {
        return (
          <label 
            key={`switch-${valor.id}-${valor.ativo}`}
            className="switch"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              updateStatus(!valor.ativo, valor.id);
            }}
          >
            {valor.ativo === 1 ? (
              <input 
                type="checkbox" 
                checked 
                readOnly
              />
            ) : (
              <input 
                type="checkbox" 
                readOnly
              />
            )}
            <span className="slider round"></span>
          </label>
        );
      },
    },
    {
      dataField: 'editar',
      isDummyField: true,
      text: 'Editar',
      sort: false,
      hidden: [1, 2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            abrirModalEditar(valor.id);
          }}
        >
          <i className="fas fa-edit"></i>
        </button>
      ),
    },
    {
      dataField: 'apagar',
      isDummyField: true,
      text: 'Apagar',
      sort: false,
      hidden: [1, 2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            abrirModalExcluir(valor.id, valor.nome);
          }}
        >
          <i className="fas fa-trash f-red"></i>
        </button>
      ),
    },
  ];

  const defaultSorted = [
    {
      dataField: 'nome',
      order: 'asc',
      sort: true,
    },
  ];

  const options = {
    sizePerPage: sizePerPage,
    totalSize: totalSize,
    showTotal: true,
    sizePerPageList: [
      {
        text: '5',
        value: 5,
      },
      {
        text: '10',
        value: 10,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: 'Todos',
        value: data.length,
      },
    ],
    paginationTotalRenderer: (from, to, size) =>
      size > 0 ? (
        <span className="react-bootstrap-table-pagination-total px-2">
          {from}-{to} de {size} resultados
        </span>
      ) : (
        <span className="react-bootstrap-table-pagination-total px-2">
          Nenhum resultado
        </span>
      ),
  };

  useEffect(() => {
    buscarPremios();
  }, [page, sizePerPage]);

  const buscarPremios = async () => {
    setBuscando(true);
    try {
      const resultado = await api.get('/api/premios', {

        params: {
          pagina: page,
          itensPorPagina: sizePerPage,
          busca: busca,
        },
      });
      if (resultado?.data) {
        setData(resultado.data.premios);
        setTotalSize(resultado.data.totalItens);
      }
    } catch (error) {
      toast.error('Erro ao buscar prêmios');
    }
    setBuscando(false);
  };

  const handleSearchChange = (e) => {
    setBusca(e.target.value);
  };

  const handleSearchClick = () => {
    buscarPremios();
  };

  async function updateStatus(state, id) {
    const resultado = await api.put(`/api/premios/${id}`, {
      ativo: state ? 1 : 0,
    });

    if (resultado) {
      toast.success('Prêmio atualizado com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });

      setData(
        data.map((d) => {
          if (d.id === id) {
            d.ativo = state ? 1 : 0;
          }
          return d;
        })
      );
      
      setTableKey(prev => prev + 1);
    }
  }

  const abrirModalExcluir = (id, premio) => {
    setPremio(premio);
    setId(id);
    setMostrarModalExcluir(true);
  };

  const fecharModalExcluir = () => {
    setPremio('');
    setId('');
    setMostrarModalExcluir(false);
  };

  const abrirModalEditar = (id) => {
    const dados = data.filter((d) => d.id === id);
    setDataEditar(dados[0]);
    setMostrarModalEditar(true);
  };

  const fecharModalEditar = () => {
    setDataEditar([]);
    setMostrarModalEditar(false);
  };

  const atualizarExclusao = (id) => {
    setData(data.filter((d) => d.id !== id));
  };

  const atualizarPremio = (dataUpdated) => {
    setData(
      data.map((d) => {
        if (d.id === dataUpdated.id) {
          d = { ...d, ...dataUpdated };
        }
        return d;
      })
    );
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    if (type === 'pagination') {
      setPage(page);
      setSizePerPage(sizePerPage);
    }
  };

  const handleSelectChange = (e, id) => {
    if (e.target.checked) {
      setSelectedIds([...selectedIds, id]);
    } else {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== id));
    }
    setTableKey(prev => prev + 1);
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allIds = data.map(item => item.id);
      setSelectedIds(allIds);
      setSelectAll(true);
    } else {
      setSelectedIds([]);
      setSelectAll(false);
    }
    setTableKey(prev => prev + 1);
  };

  const handleBulkActivate = async () => {
    if (selectedIds.length === 0) {
      toast.warning('Selecione pelo menos um prêmio');
      return;
    }

    try {
      const response = await api.put('/api/premios/bulk-activate', {
        ids: selectedIds,
        ativo: 1
      });

      toast.success(response.data.mensagem, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
      
      setData(data.map(item => 
        selectedIds.includes(item.id) ? { ...item, ativo: 1 } : item
      ));
      
      setSelectedIds([]);
      setSelectAll(false);
      setTableKey(prev => prev + 1);
    } catch (error) {
      toast.error('Erro ao ativar prêmios');
    }
  };

  const handleBulkDeactivate = async () => {
    if (selectedIds.length === 0) {
      toast.warning('Selecione pelo menos um prêmio');
      return;
    }

    try {
      const response = await api.put('/api/premios/bulk-activate', {
        ids: selectedIds,
        ativo: 0
      });

      toast.success(response.data.mensagem, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
      
      setData(data.map(item => 
        selectedIds.includes(item.id) ? { ...item, ativo: 0 } : item
      ));
      
      setSelectedIds([]);
      setSelectAll(false);
      setTableKey(prev => prev + 1);
    } catch (error) {
      toast.error('Erro ao inativar prêmios');
    }
  };

  const abrirModalLimite = (premio) => {
    setPremioLimite(premio);
    setMostrarModalLimite(true);
  };

  const fecharModalLimite = () => {
    setPremioLimite(null);
    setMostrarModalLimite(false);
  };

  const atualizarLimiteResgate = (premioAtualizado) => {
    setData(
      data.map((d) => {
        if (d.id === premioAtualizado.id) {
          return { ...d, ...premioAtualizado };
        }
        return d;
      })
    );
    setTableKey(prev => prev + 1);
  };

  return (
    <Container fluid>
      <h4 className="pt-3 pb-3 f-black">Prêmios</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <div>
        {/* Botões de ação em massa */}
        {selectedIds.length > 0 && (
          <div className="d-flex align-items-center mb-3 p-3 bg-light rounded">
            <span className="mr-3">
              <strong>{selectedIds.length}</strong> prêmio(s) selecionado(s)
            </span>
            <button 
              onClick={handleBulkActivate}
              className="btn btn-success mr-2"
            >
              <i className="fas fa-check mr-1"></i>
              Ativar Selecionados
            </button>
            <button 
              onClick={handleBulkDeactivate}
              className="btn btn-danger mr-2"
            >
              <i className="fas fa-times mr-1"></i>
              Inativar Selecionados
            </button>
          </div>
        )}

        <ToolkitProvider
          bootstrap4
          keyField="id"
          data={data}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <div className="d-flex justify-content-end mb-3">
                <input
                  value={busca}
                  onChange={handleSearchChange}
                  className="input-theme"
                  placeholder="Buscar"
                />
                <button onClick={handleSearchClick} className="btn btn-primary ml-2">
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <BootstrapTable
                key={`table-${tableKey}`}
                {...props.baseProps}
                remote={{ pagination: true }}
                onTableChange={handleTableChange}
                noDataIndication={() =>
                  buscando ? (
                    <span>
                      Carregando
                      <i className="fas fa-circle-notch fa-spin ml-3"></i>
                    </span>
                  ) : (
                    <span>Sem resultados</span>
                  )
                }
                classes="table-dark text-center rounded"
                wrapperClasses="rounded"
                bordered={false}
                pagination={paginationFactory(options)}
                defaultSorted={defaultSorted}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
      <ModalExcluir
        show={mostrarModalExcluir}
        onHide={fecharModalExcluir}
        premio={premio}
        id={id}
        atualizarExclusao={atualizarExclusao}
      />
      <ModalEditar
        show={mostrarModalEditar}
        onHide={fecharModalEditar}
        data={dataEditar}
        atualizarPremio={atualizarPremio}
      />
      <ModalLimiteResgate
        show={mostrarModalLimite}
        onHide={fecharModalLimite}
        premio={premioLimite}
        onSuccess={atualizarLimiteResgate}
      />
    </Container>
  );
}
